import {Provider} from "./provider";
import {Event} from "../event";
import {log} from "../../util/log";

interface IAndroidEvent {
    event_name: string;
    actionName: string;
    tagName: string;
}

export class AndroidProvider extends Provider<IAndroidEvent> {
    /* STATIC */

    /* INSTANCE */
    override parse(data: Event): IAndroidEvent {
        return {
            event_name: 'cmp',
            actionName: data.action,
            tagName: data.label
        };
    }

    override send(data: IAndroidEvent) {
        const iface = (window as any)['AnalyticsCMPInterface'];
        if (iface) {
            iface.sendEvent(JSON.stringify(data));
        } else {
            log.debug('AnalyticsCMPInterface not found');
        }
    }
}
